
import { Options, Vue } from "vue-class-component";
import { ref } from "vue";
import * as echarts from "echarts";

import {
  dispatchGetReportStat,
  dispatchGetVisitStatistics,
  dispatchGetVisitStatTrend,
  dispatchGetTopPerformance,
  dispatchGetTopProjectPerformance,
  dispatchGetTopMainLabelPerformance,
  dispatchGetTopModelPerformance,
  dispatchGetTopLevelPerformance,
  dispatchGetTopTesterPerformance,
  dispatchGetProjects,
  dispatchGetTopPerformanceList,
  dispatchGetMyProjects,
} from "@/store/project/actions";
import { dispatchCreateSceneScriptTop } from "@/store/task/actions";
import { store } from "@/store";
import Quill from "quill";
import { ElMessage } from "element-plus";
import {
  compare,
  dateConversion,
  getLocalProject,
  special_projects,
  unique_json,
} from "@/utils";
import { readUserProfile } from "@/store/main/getters";
import {
  readAdminProjects,
  readMyProjects,
  readProjectDetail,
  readTopProjectScenes,
} from "@/store/project/getters";
import {
  dispatchGetProjectDetail,
  dispatchGetProjectScenes,
  dispatchUpdateProject,
  dispatchTopCreateProjectScenes,
  dispatchGetTopProjectScenes,
  dispatchGetTopOptions,
  dispatchGetTopPerformanceListAdvance,
} from "@/store/project/actions";
import {
  readReportStat,
  readVisitStatistics,
  readVisitStatTrend,
  readtopPerformance,
  readtopProjectPerformance,
  readtopPerformanceList,
  readtopMainLabelPerformance,
  readtopModelPerformance,
  readtopLevelPerformance,
  readtopTesterPerformance,
  readtopProjectTopOptions,
  readtopPerformanceListAdvance,
} from "@/store/project/getters";
import {
  readTopBaselines,
  readTopTemplates,
  readTopTemplatesData,
  readTopBaselinesData,
} from "@/store/performance/getters";
import {
  dispatchDeepTopDownLoad,
  dispatchUploadTopPerformance,
  dispatchDeletetopPerformance,
  dispatchUploadPerformanceUpload,
  dispatchAddBug,
  dispatchGetProblemSummay,
  dispatchGetTopTemplates,
  dispatchTopTemplatesCreate,
  dispatchTopTemplatesEdit,
  dispatchGetTopTemplatesData,
  dispatchTopBaselinesCreate,
  dispatchGetTopBaselines,
  dispatchGetTopBaselinesData,
  dispatchTopBaselinesEdit,
  dispatchUploadPerformanceTable,
  dispatcTopDataEdit,
} from "@/store/performance/actions";

import { readUploadTopPerformanceLoad } from "@/store/performance/getters";
// @Options({
//   components: {},
// })
export default class OperationalData extends Vue {
  public localProject = Number(getLocalProject());
  public current_page = 1;
  public loadProgress = 0; // 动态显示进度条
  public progressFlag = false; // 关闭进度条
  public courseSize = 10;
  public courseCurrentPage = 1;
  public filterScript = "";
  public top_project_old = "";
  public top_project = "";
  public top_version = "";
  public get projectList() {
    return readtopProjectPerformance(store);
  }
  public topChange() {
    this.courseCurrentPage_top = 1;
    this.top_size = 10;

    dispatchGetTopPerformanceList(store, {
      project: this.localProject,
      page: this.courseCurrentPage_top,
      size: this.top_size,
      project_id: this.top_project_old,
      model_name: this.top_project,
      version: this.top_version,
    });
  }
  public async ploadImage(param: any) {
    if (param.file === undefined) {
      document
        .getElementsByClassName("el-upload")[0]
        .setAttribute("style", "display: inline-block");
    } else {
      document
        .getElementsByClassName("el-upload")[0]
        .setAttribute("style", "display: none");
    }
    this.formData2.set("file", param.file);
  }
  public test_time = "";
  public peload_show = false;
  public async submitAddForm() {
    this.dialogAddFormVisible = false;
    // 调用创建场景脚本接口
    this.formData2.set("project_id", this.filterScript);
    this.formData2.set("version", this.topProjectVersion);
    this.formData2.set("project", this.localProject);
    let b = (this as any).$message({
      //Message 消息提示
      message: "上传中",
      showClose: true,
      duration: 0,
    });
    await dispatchCreateSceneScriptTop(store, this.formData2).then((res) => {
      this.test_time = res.test_time;
    });
    b.close();
    ElMessage.success({
      message: "数据上传成功",
      showClose: true,
      type: "success",
    });
    this.formData2 = new FormData();
    await dispatchGetTopOptions(store, {
      project: this.localProject,
    });
    this.courseCurrentPage_top = 1;
    this.top_size = 10;
    this.peload_size = 10;
    this.peload_currentPage = 1;
    this.top_project = "";
    this.top_version = "";
    this.top_project_old = this.filterScript;
    this.top_version = this.topProjectVersion;
    await dispatchGetTopPerformanceListAdvance(store, {
      project: this.localProject,
      page: this.peload_currentPage,
      size: this.peload_size,
      is_valid: 0,
      project_id: this.filterScript,
      version: this.topProjectVersion,
      test_time: this.test_time,
    });
    this.peload_show = true;
    dispatchGetTopPerformanceList(store, {
      project: this.localProject,
      page: this.courseCurrentPage_top,
      size: this.top_size,
      project_id: this.filterScript,
      model_name: this.top_project,
      version: this.top_version,
    });
    // document
    //   .getElementsByClassName("el-upload")[0]
    //   .setAttribute("style", "display: inline-block");
    // (this.$refs["upload"] as any).clearFiles();
    // // 隐藏新建表单
    // this.dialogAddFormVisible = false;
    // // await dispatchGetScripts(store, { project: this.project, page: this.currentPage1, size: this.record, script_name: this.addForm.chinese })
    // await dispatchGetScripts(store, {
    //   project: this.project,
    //   page: this.currentPage1,
    //   script_name: this.search1,
    //   size: this.record,
    // });
    // this.totalNum = this.getVisitStatistics.count + 1; //分页总数
    // await this.onPaging(this.record, 1);
    // // await dispatchGetSimpleScripts(store, { project: this.project })
    // await dispatchGetProjectScenes(store, { project: this.project });
  }
  public get topDataList() {
    return readtopProjectTopOptions(store);
  }
  public handleAddScriptV2() {
    this.dialogAddFormVisible = true;
    this.filterScript = "";
    dispatchGetTopProjectScenes(store, {
      project: this.localProject,
    });
  }
  public get topProjectScenes() {
    return readTopProjectScenes(store);
  }
  public get tagList() {
    return readtopMainLabelPerformance(store);
  }
  public get top_temp_list() {
    return readTopTemplates(store);
  }
  public closeAddScript() {
    this.addScript = false;
  }
  public resetAddForm(formName: any) {
    (this.$refs[formName] as any).resetFields();
    document
      .getElementsByClassName("el-upload")[0]
      .setAttribute("style", "display: inline-block");
    (this.$refs["upload"] as any).clearFiles();
    this.dialogAddFormVisible = false;
  }

  public get top_base_list() {
    return readTopBaselines(store);
  }
  public openAddScript() {
    this.addScript = true;
    this.addScriptForm = {
      chinese: "",
      game: "",
      team: "",
      project_key: "",
      data: "",
    };
  }
  public btn_name = "";
  public form_value = "";
  public async moduleChange() {
    this.htmlShow = true;

    this.btnName();
    if (this.basic_form.value != "") {
      this.basic_form.name = this.top_temp_list.filter(
        (v) => v.id == this.basic_form.value
      )[0].name;
      await dispatchGetTopTemplatesData(store, {
        id: this.basic_form.value,
        project: this.localProject,
      });
      this.htmlValue = this.templatesData.content;
      this.basic_form.name = this.templatesData.name;
      this.basic_form.title = this.templatesData.project_name;
      this.basic_form.degree = this.templatesData.degree;
      this.basic_form.discovered_version = this.templatesData.version_report;
      this.basic_form.processed_by = this.templatesData.current_owner;
      this.basic_form.discovery_phase = this.templatesData.originphase;
    } else {
      this.basic_form.title = this.project_name();
      this.basic_form.processed_by = "";
      this.basic_form.degree = "";
      this.basic_form.discovered_version = "";
      this.basic_form.discovery_phase = "";
      this.basic_form.name = "";
      this.htmlValue =
        '<p style="line-height:35px;font-size:14px">游戏客户端版本号:</p><p style="line-height:35px;font-size:14px">测试服务器:</p><p style="line-height:35px;font-size:16px;font-weight:bold;">【操作步骤】</p><p style="line-height:35px;font-size:14px">1、使用设备链接perfdog工具</p><p style="line-height:35px;font-size:14px">2、根据性能用例进行性能数据采集</p><p style="line-height:35px;font-size:14px">3、操作过程中查看性能数据和游戏表现</p><p style="line-height:35px;font-size:16px;font-weight:bold;">【问题描述】</p><p style="line-height:35px;font-size:14px">自动生成</p><p style="line-height:35px;font-size:16px;font-weight:bold;">【在线文档】</p><p style="line-height:35px;font-size:16px;font-weight:bold;">文档链接:</p>';
    }
  }
  public async editConfigurationShow() {
    this.configurationShow = !this.configurationShow;

    if (this.configurationShow == true) {
      let setting: any = {
        stuck_baseline: {},
        hot_baseline: {},
        crash_baseline: {},
        fps_baseline: {},
        pss_baseline: {},
      };
      this.baseline_data.forEach((item) => {
        if (item.name === "主观卡顿") {
          setting.stuck_baseline.name = item.name;
          setting.stuck_baseline.pass = item.pass_text.split("、");
          setting.stuck_baseline.no_pass = item.no_pass_text.split("、");
        }
        if (item.name === "主观发热") {
          setting.hot_baseline.name = item.name;
          setting.hot_baseline.pass = item.pass_text.split("、");
          setting.hot_baseline.no_pass = item.no_pass_text.split("、");
        }
        if (item.name === "是否闪退") {
          setting.crash_baseline.name = item.name;
          setting.crash_baseline.pass = item.pass_text.split("、");
          setting.crash_baseline.no_pass = item.no_pass_text.split("、");
        }
      });
      this.baseline_data_fps.forEach((v) => {
        setting.fps_baseline[v[0].name] = {};
        v.forEach((item) => {
          setting.fps_baseline[v[0].name][item.module] = {
            AvgFPS: item.avgFps,
            ["MaxPSS(MB)"]: item.maxPss,
            ["最高温度"]: item["最高温度"],
          };
        });
      });
      this.baseline_data_Picture.forEach((v) => {
        setting.pss_baseline[v[0].name] = {};
        v.forEach((item) => {
          setting.pss_baseline[v[0].name][item.module] = {
            ["MaxPSS(MB)"]: item.maxPss,
          };
        });
      });

      if (this.configuration_name != "") {
        if (this.basic_value == "") {
          await dispatchTopBaselinesCreate(store, {
            project: this.localProject,
            project_name: this.configuration_name,
            settings: JSON.stringify(setting),
          });

          ElMessage.success({
            message: "创建基线成功",
            showClose: true,
            type: "success",
          });
        } else {
          await dispatchTopBaselinesEdit(store, {
            project: this.localProject,
            id: this.basic_value,
            project_name: this.configuration_name,
            settings: JSON.stringify(setting),
          });
          ElMessage.success({
            message: "编辑基线成功",
            showClose: true,
            type: "success",
          });
        }
        await dispatchGetTopBaselines(store, {
          project: this.localProject,
        });
        this.basic_value = this.top_base_list.filter(
          (v) => v.project_name == this.configuration_name
        )[0].id;
        // this.current_page = 1;
        // this.courseSize = 10;
        // this.checkedCities = ["默认画质"];
        // await dispatchGetProblemSummay(store, {
        //   project: this.localProject,
        //   id_list: this.checkList,
        //   project_name: this.basic_value
        //     ? this.top_base_list.filter((v) => v.id == this.basic_value)[0]
        //         .project_name
        //     : "",
        // });
        //  this.activeName = "thread";
      } else {
        this.configurationShow = false;
        ElMessage.error({
          message: "请填写基线名",
          showClose: true,
          type: "error",
        });
      }
    }
  }
  public configuration_name = "";
  public basic_value = "";
  public closeBtn() {
    dispatcTopDataEdit(store, {
      project: this.localProject,
      version: this.topProjectVersion,
      project_id: this.filterScript,

      test_time: this.test_time,
      valid: 0,
    });
  }
  public save_btn() {
    dispatcTopDataEdit(store, {
      project: this.localProject,
      version: this.topProjectVersion,
      project_id: this.filterScript,

      test_time: this.test_time,
      valid: 1,
    });
    ElMessage.success({
      message: "保存成功",
      showClose: true,

      type: "success",
    });
    dispatchGetTopPerformanceList(store, {
      project: this.localProject,
      page: this.courseCurrentPage_top,
      size: this.top_size,
      project_id: this.top_project_old,
      model_name: this.top_project,
      version: this.top_version,
    });

    this.peload_show = false;
  }
  public async editHtml() {
    this.htmlShow = !this.htmlShow;
    this.btnName();
    if (this.htmlShow == true) {
      if (this.basic_form.value) {
        await dispatchTopTemplatesEdit(store, {
          id: this.basic_form.value,
          project: this.localProject,
          name: this.basic_form.name,
          project_name: this.basic_form.title,
          originphase: this.basic_form.discovery_phase,
          current_owner: this.basic_form.processed_by,
          content: this.htmlValue,
          severity: this.basic_form.degree,
          version_report: this.basic_form.discovered_version,
        });
        await await dispatchGetTopTemplates(store, {
          project: this.localProject,
        });
        ElMessage.success({
          message: "保存成功",
          showClose: true,
          type: "success",
        });
      } else {
        if (this.basic_form.name) {
          await dispatchTopTemplatesCreate(store, {
            project: this.localProject,
            name: this.basic_form.name,
            project_name: this.basic_form.title,
            originphase: this.basic_form.discovery_phase,
            current_owner: this.basic_form.processed_by,
            content: this.htmlValue,
            severity: this.basic_form.degree,
            version_report: this.basic_form.discovered_version,
          });
          await dispatchGetTopTemplates(store, {
            project: this.localProject,
          });
          this.basic_form.value = this.top_temp_list.filter(
            (v) => v.name == this.basic_form.name
          )[0].id;
          ElMessage.success({
            message: "创建模板成功",
            showClose: true,
            type: "success",
          });
        } else {
          ElMessage.error({
            message: "请填写模板名",
            showClose: true,
            type: "error",
          });
          return;
        }
      }
    }
  }
  public htmlDefault() {
    this.htmlShow = true;
    this.btnName();
    this.basic_form.value = "";
    this.basic_form.title = this.project_name();
    this.basic_form.processed_by = "";
    this.basic_form.degree = "";
    this.basic_form.discovered_version = "";
    this.basic_form.discovery_phase = "";
    this.basic_form.name = "";
    this.htmlValue =
      '<p style="line-height:35px;font-size:14px">游戏客户端版本号:</p><p style="line-height:35px;font-size:14px">测试服务器:</p><p style="line-height:35px;font-size:16px;font-weight:bold;">【操作步骤】</p><p style="line-height:35px;font-size:14px">1、使用设备链接perfdog工具</p><p style="line-height:35px;font-size:14px">2、根据性能用例进行性能数据采集</p><p style="line-height:35px;font-size:14px">3、操作过程中查看性能数据和游戏表现</p><p style="line-height:35px;font-size:16px;font-weight:bold;">【问题描述】</p><p style="line-height:35px;font-size:14px">自动生成</p><p style="line-height:35px;font-size:16px;font-weight:bold;">【在线文档】</p><p style="line-height:35px;font-size:16px;font-weight:bold;">文档链接:</p>';
  }
  public async creatBtn() {
    this.basic_form.title = this.project_name();
    this.basic_form.processed_by = "";
    this.basic_form.degree = "";
    this.basic_form.discovered_version = "";
    this.basic_form.discovery_phase = "";
    this.basic_form.name = "";
    this.basic_form.value = "";
    this.htmlValue =
      '<p style="line-height:35px;font-size:14px">游戏客户端版本号:</p><p style="line-height:35px;font-size:14px">测试服务器:</p><p style="line-height:35px;font-size:16px;font-weight:bold;">【操作步骤】</p><p style="line-height:35px;font-size:14px">1、使用设备链接perfdog工具</p><p style="line-height:35px;font-size:14px">2、根据性能用例进行性能数据采集</p><p style="line-height:35px;font-size:14px">3、操作过程中查看性能数据和游戏表现</p><p style="line-height:35px;font-size:16px;font-weight:bold;">【问题描述】</p><p style="line-height:35px;font-size:14px">自动生成</p><p style="line-height:35px;font-size:16px;font-weight:bold;">【在线文档】</p><p style="line-height:35px;font-size:16px;font-weight:bold;">文档链接:</p>';
    this.htmlShow = false;
    this.btnName();
  }
  public addScriptForm = {
    chinese: "",
    game: "",
    project_key: "",
    team: "",
    data: "",
  };
  public secondData() {
    this.baseline_data = [];
    this.baseline_data_fps = [];
    this.baseline_data_Picture = [];
    this.baseline_data.push(
      this.stuck_baseline,
      this.hot_baseline,
      this.crash_baseline
    );
    for (let i in this.fps_baseline) {
      let list = [];
      for (let item in this.fps_baseline[i]) {
        list.push({
          name: i,
          module: item,
          avgFps: this.fps_baseline[i][item].AvgFPS,
          maxPss: this.fps_baseline[i][item]["MaxPSS(MB)"],
          最高温度: this.fps_baseline[i][item]["最高温度"],
        });
      }
      this.baseline_data_fps.push(list);
    }
    for (let i in this.pss_baseline) {
      let list = [];
      for (let item in this.pss_baseline[i]) {
        list.push({
          name: i,
          module: item,
          maxPss: this.pss_baseline[i][item]["MaxPSS(MB)"],
        });
      }
      this.baseline_data_Picture.push(list);
      this.baseline_data.forEach((v) => {
        v.no_pass_text = v.no_pass.join("、");
        v.pass_text = v.pass.join("、");
      });
    }
    this.spanArr = [];
    this.baseline_data_fps.forEach((item) => {
      this.getSpanArr(item);
    });
  }
  public async addAddScript() {
    let list = [];
    let data = ["chinese", "project_key", "data", "game"];
    data.forEach((v) => {
      if (!this.addScriptForm[v]) {
        list.push(v);
      }
    });
    console.log(list);
    if (list.length > 0) {
      let string = "";
      let type = {
        chinese: "游戏名称",
        project_key: "游戏英文名称",
        data: "游戏种类",
        game: "数据分类",
      };
      list.forEach((v, index) => {
        string += list.length - 1 == index ? type[v] : type[v] + ",";
      });

      ElMessage.error({
        message: string + "不能为空",
        showClose: true,
        type: "error",
      });
      return;
    } else {
      await dispatchTopCreateProjectScenes(store, {
        // original_scene_id: Number(this.addScriptForm.original_scene_id),
        project_name: this.addScriptForm.chinese,
        project: this.localProject,
        project_key: this.addScriptForm.project_key,
        data_type: this.addScriptForm.data,
        game_type: this.addScriptForm.game,
        team: this.addScriptForm.team,
      });
      ElMessage({
        message: "场景创建成功",
        type: "success",
      });
      dispatchGetTopProjectScenes(store, {
        project: this.localProject,
      });
      this.addScript = false;
    }
  }
  public createConfiguration() {
    // this.basic_value=''
    // this.configuration_name=''
    // this.secondData()

    this.configurationShow = !this.configurationShow;

    // this.configurationShow=false
    if (this.configurationShow == true) {
      if (this.basic_value == "") {
        this.secondData();
      } else {
        this.linechangeData();
      }
    } else {
      this.basic_value = "";
      this.configuration_name = "";
      this.secondData();
    }
  }
  public dialogAddFormVisible = false;
  public addScript = false;
  public htmlShow = true;
  public configurationShow = true;
  public htmlValue2 = "";
  public degree = [
    { name: "致命", value: "fatal" },
    { name: "严重", value: "serious" },
    { name: "一般", value: "normal" },
    { name: "提示", value: "prompt" },
    { name: "建议", value: "advice" },
  ];
  public basic_form = {
    title: "",
    processed_by: "",
    degree: "",
    discovered_version: "",
    discovery_phase: "",
    name: "",
    value: "",
  };
  public htmlAllBtn() {
    if (this.form_problem === "") {
      ElMessage.error({
        message: "请选择提单方式",
        showClose: true,
        type: "error",
      });
      return;
    }
    let b = (this as any).$message({
      //Message 消息提示
      message: "提交中",
      showClose: true,
      duration: 0,
    });
    this.problemData.forEach((v) => {
      v["提单状态"] = 1;
    });
    this.dialogVisible6 = false;
    if (this.form_problem === "按问题提单") {
      let all_length = [];
      let false_length = [];
      let index = 0;

      this.problemData.forEach((v) => {
        this.problemListEdit.forEach((item) => {
          let list = v[item].res.filter((m) => m != "✔" && m != "-");

          let url = "";
          if (list) {
            url = v[item].url;
          }
          list.forEach((data) => {
            false_length.push(data);
          });
          v[item].res.forEach((x) => {
            all_length.push(x);
          });
        });
      });
      this.problemData.forEach((v) => {
        let numHead = "";
        let checkHead = "";

        this.problemList.forEach((s) => {
          numHead += `<td style="border:1px solid #d9d9d9;font-weight:bold">${v[s]}</td>`;
        });
        this.checkedCities.forEach((s) => {
          checkHead += `<td style="border:1px solid #d9d9d9;font-weight:bold">${v[s]}</td>`;
        });
        this.problemListEdit.forEach((item) => {
          let list = v[item].res.filter((m) => m != "✔" && m != "-");

          let url = "";
          if (list) {
            url = v[item].url;
          }
          list.forEach((data, i) => {
            index++;

            let title = `【Top客户端性能】【按问题分类】【${this.basic_form.title}】【${v["设备型号"]}】${item}场景性能数据不达标`;
            this.htmlValue2 = `<p><table style="width:200px;border:1px solid #e2e7eb;border-collapse:collapse;font-size:14px; text-align: center;"><tr style="background:#5D99D5;border-width:0">${this.numHead}${this.checkHead}<td style="color:#fff">${item}</td></tr><tr style="border-width:0">${numHead}${checkHead}<td style="border:1px solid #d9d9d9;color:red;font-weight:bold">${data}</td></tr></table></p><p style="line-height:35px;font-size:14px">${item}:<a href="${url}">perfdog链接</a></p>`;
            this.html_SP();
            let text = this.up_string + this.htmlValue2 + this.down_string;
            //  计算false_length目的得出最后一个调用
            if (index == false_length.length) {
              dispatchAddBug(store, {
                project: this.localProject,
                title: title,
                description: text,
                current_owner: this.basic_form.processed_by,
                originphase: this.basic_form.discovery_phase,
                severity: this.basic_form.degree,
                version_report: this.basic_form.discovered_version,
              }).then((res) => {
                if (res) {
                  b.close();
                  if (
                    all_length.length != false_length.length &&
                    false_length.length != 0
                  ) {
                    ElMessage.success({
                      message: `<p>共提单${false_length.length}个：<a target="_blank" href="https://tapd.woa.com/tapd_fe/70086063/bug/list?page=1&confId=1070086063078555265">点击查看</a>`,
                      showClose: true,
                      type: "success",
                      dangerouslyUseHTMLString: true,
                    });
                  }
                  if (false_length.length == 0) {
                    ElMessage.success({
                      message: "没有问题提单",
                      showClose: true,
                      dangerouslyUseHTMLString: true,
                      type: "success",
                    });
                  }
                  if (all_length.length === false_length.length) {
                    ElMessage.success({
                      message: `<p>共提单${false_length.length}个：<a target="_blank" href="https://tapd.woa.com/tapd_fe/70086063/bug/list?page=1&confId=1070086063078555265">点击查看</a>`,
                      showClose: true,
                      dangerouslyUseHTMLString: true,
                      type: "success",
                    });
                  }
                }
              });
            } else {
              dispatchAddBug(store, {
                project: this.localProject,
                title: title,
                description: text,
                current_owner: this.basic_form.processed_by,
                originphase: this.basic_form.discovery_phase,
                severity: this.basic_form.degree,
                version_report: this.basic_form.discovered_version,
              });
            }
          });
        });
      });
    }
    if (this.form_problem === "按场景提单") {
      let false_length = [];
      let td_all = "";
      let index = 0;
      let all_length = [];
      // 计算出有的个数
      this.problemData.forEach((v) => {
        this.problemListEdit.forEach((item) => {
          let list = v[item].res.filter((m) => m != "✔" && m != "-");

          let text = "";
          let url = "";
          list.forEach((k, i) => {
            text += `<p>${i + 1}、${k}</p>`;
            url += `<p style="line-height:35px;font-size:14px">${item}:<a href=${v[item].url}>perfdog链接</a></p>`;
          });
          all_length.push(text);
          if (text != "") {
            false_length.push(text);
          }
        });
      });
      //  分步骤
      this.problemData.forEach((v) => {
        let numHead = "";
        let checkHead = "";

        this.problemList.forEach((s) => {
          numHead += `<td style="border:1px solid #d9d9d9;font-weight:bold">${v[s]}</td>`;
        });
        this.checkedCities.forEach((s) => {
          checkHead += `<td style="border:1px solid #d9d9d9;font-weight:bold">${v[s]}</td>`;
        });
        this.problemListEdit.forEach((item) => {
          let list = v[item].res.filter((m) => m != "✔" && m != "-");

          let text = "";
          let url = "";
          list.forEach((k, i) => {
            text += `<p>${i + 1}、${k}</p>`;
            url += `<p style="line-height:35px;font-size:14px">${item}:<a href=${v[item].url}>perfdog链接</a></p>`;
          });

          if (text != "") {
            index++;
            let title = `【Top客户端性能】【按场景分类】【${this.basic_form.title}】【${v["设备型号"]}】${item}场景性能数据不达标`;
            this.htmlValue2 = `<table style="width:200px;border:1px solid #e2e7eb;border-collapse:collapse;font-size:14px; text-align: center;"><tr style="background:#5D99D5;border-width:0">${this.numHead}${this.checkHead}<td style="color:#fff">${item}</td></tr><tr style="border-width:0">${numHead}${checkHead}<td style="border:1px solid #d9d9d9;color:red;font-weight:bold">${text}</td></tr></table>${url}`;
            this.html_SP();
            if (index == false_length.length) {
              dispatchAddBug(store, {
                project: this.localProject,
                title: title,
                description:
                  this.up_string + this.htmlValue2 + this.down_string,
                current_owner: this.basic_form.processed_by,
                originphase: this.basic_form.discovery_phase,
                severity: this.basic_form.degree,
                version_report: this.basic_form.discovered_version,
              }).then((res) => {
                if (res) {
                  b.close();
                  if (
                    all_length.length != false_length.length &&
                    false_length.length != 0
                  ) {
                    ElMessage.success({
                      message: `<p>共提单${false_length.length}个：<a target="_blank" href="https://tapd.woa.com/tapd_fe/70086063/bug/list?page=1&confId=1070086063078555265">点击查看</a>`,
                      showClose: true,
                      dangerouslyUseHTMLString: true,
                      type: "success",
                    });
                  }
                  if (false_length.length == 0) {
                    ElMessage.success({
                      message: "没有问题提单",
                      showClose: true,

                      type: "success",
                    });
                  }
                  if (all_length.length == false_length.length) {
                    ElMessage.success({
                      message: `<p>共提单${false_length.length}个：<a target="_blank" href="https://tapd.woa.com/tapd_fe/70086063/bug/list?page=1&confId=1070086063078555265">点击查看</a>`,
                      showClose: true,
                      dangerouslyUseHTMLString: true,
                      type: "success",
                    });
                  }
                }
              });
            } else {
              dispatchAddBug(store, {
                project: this.localProject,
                title: title,
                description:
                  this.up_string + this.htmlValue2 + this.down_string,
                current_owner: this.basic_form.processed_by,
                originphase: this.basic_form.discovery_phase,
                severity: this.basic_form.degree,
                version_report: this.basic_form.discovered_version,
              });
            }
          }
        });
      });
    }
    if (this.form_problem === "按机型提单") {
      //  计算个数
      let false_length = [];
      this.problemData.forEach((v) => {
        let str = "";
        let num = 0;
        this.problemListEdit.forEach((item) => {
          let list = v[item].res.filter((v) => v != "✔" && v != "-");

          list.forEach((k, i) => {
            num++;
            str += `<p>${num}、${item}场景下${k}</p>`;
          });
        });
        if (str != "") {
          false_length.push(str);
        }
      });
      //  分步骤
      let index = 0;
      this.problemData.forEach((v, i) => {
        let str = "";
        let num = 0;

        let thead_all = "";
        let tbody_all = "";
        let scene_all = "";
        let url = "";
        let numHead = "";
        let checkHead = "";

        this.problemList.forEach((s) => {
          numHead += `<td style="border:1px solid #d9d9d9;font-weight:bold">${v[s]}</td>`;
        });
        this.checkedCities.forEach((s) => {
          checkHead += `<td style="border:1px solid #d9d9d9;font-weight:bold">${v[s]}</td>`;
        });
        this.problemListEdit.forEach((item) => {
          let list = v[item].res.filter((v) => v != "✔" && v != "-");
          let text = "";
          list.forEach((k, i) => {
            text += `<p>${i + 1}、${k}</p>`;
            num++;
            str += `<p>${num}、${item}场景下${k}</p>`;
            if (text != "") {
              url += `<p style="line-height:35px;font-size:14px">${item}:<a href=${v[item].url}>perfdog链接</a></p>`;
              tbody_all += `<td style="border:1px solid #d9d9d9;color:red;font-weight:bold">${text}</td>`;
              thead_all += `<td style="border:1px solid #d9d9d9;color:#fff">${item}</td>`;
              scene_all += `${item}、`;
            }
          });
        });
        if (str != "") {
          index++;

          (this.htmlValue2 = `<table style="border:1px solid #e2e7eb;border-collapse:collapse;font-size:14px; text-align: center;"><tr style="background:#5D99D5;border-width:0">${this.numHead}${this.checkHead}${thead_all}</tr><tr style="border-width:0">${numHead}${checkHead}${tbody_all}</tr></table>${url}`),
            this.html_SP();

          if (index == false_length.length && false_length.length != 0) {
            dispatchAddBug(store, {
              project: this.localProject,
              title: `【Top客户端性能】【按机型分类】【${
                this.basic_form.title
              }】【${v["设备型号"]}】多场景(${scene_all.substring(
                0,
                scene_all.length - 1
              )})性能数据不达标`,
              description: this.up_string + this.htmlValue2 + this.down_string,
              current_owner: this.basic_form.processed_by,
              originphase: this.basic_form.discovery_phase,
              severity: this.basic_form.degree,
              version_report: this.basic_form.discovered_version,
            }).then((res) => {
              if (res) {
                b.close();
                if (
                  this.problemData.length != false_length.length &&
                  false_length.length != 0
                ) {
                  ElMessage.success({
                    message: `<p>共提单${false_length.length}个：<a target="_blank" href="https://tapd.woa.com/tapd_fe/70086063/bug/list?page=1&confId=1070086063078555265">点击查看</a>`,
                    showClose: true,
                    type: "success",
                    dangerouslyUseHTMLString: true,
                  });
                }
                if (false_length.length == 0) {
                  ElMessage.success({
                    message: "没有问题提单",
                    showClose: true,
                    dangerouslyUseHTMLString: true,
                    type: "success",
                  });
                }
                if (this.problemData.length === false_length.length) {
                  ElMessage.success({
                    message: `<p>共提单${false_length.length}个：<a target="_blank" href="https://tapd.woa.com/tapd_fe/70086063/bug/list?page=1&confId=1070086063078555265">点击查看</a>`,
                    showClose: true,
                    dangerouslyUseHTMLString: true,
                    type: "success",
                  });
                }
              }
            });
          } else {
            dispatchAddBug(store, {
              project: this.localProject,
              title: `【Top客户端性能】【按机型分类】【${
                this.basic_form.title
              }】【${v["设备型号"]}】多场景(${scene_all.substring(
                0,
                scene_all.length - 1
              )})性能数据不达标`,
              description: this.up_string + this.htmlValue2 + this.down_string,
              current_owner: this.basic_form.processed_by,
              originphase: this.basic_form.discovery_phase,
              severity: this.basic_form.degree,
              version_report: this.basic_form.discovered_version,
            });
          }
        }
      });
    }
  }
  public htmlBtn() {
    if (this.form_problem === "") {
      ElMessage.error({
        message: "请选择提单方式",
        showClose: true,
        type: "error",
      });
      return;
    }
    this.dialogVisible3 = false;
    this.problem_data["提单状态"] = 1;
    //  let n=(this.htmlValue.indexOf('述'))
    if (this.form_problem === "按问题提单") {
      let all_length = [];
      let false_length = [];
      let numHead = "";
      let checkHead = "";
      this.problemList.forEach((v) => {
        numHead += `<td style="border:1px solid #d9d9d9;font-weight:bold">${this.problem_data[v]}</td>`;
      });
      this.checkedCities.forEach((v) => {
        checkHead += `<td style="border:1px solid #d9d9d9;font-weight:bold">${this.problem_data[v]}</td>`;
      });
      this.problemListEdit.forEach((v, index) => {
        let list = this.problem_data[v].res.filter((v) => v != "✔" && v != "-");
        this.problem_data[v].res.forEach((i) => {
          all_length.push(i);
        });
        let url = "";
        if (list) {
          url = this.problem_data[v].url;
        }
        list.forEach((k, i) => {
          index++;
          false_length.push(k);
          // let title = this.device_name + "-" + v + "-" + this.form_problem;
          let title = `【Top客户端性能】【按问题分类】【${this.basic_form.title}】【${this.device_name}】${v}场景性能数据不达标`;
          // let text = `<p>${v}场景下${k}<p>`;
          this.htmlValue2 = `<p><table style="width:200px;border:1px solid #e2e7eb;border-collapse:collapse;font-size:14px; text-align: center;"><tr style="background:#5D99D5;border-width:0">${this.numHead}${this.checkHead}<td style="color:#fff">${v}</td></tr><tr style="border-width:0">${numHead}${checkHead}<td style="border:1px solid #d9d9d9;color:red;font-weight:bold">${k}</td></tr></table></p><p style="line-height:35px;font-size:14px">${v}:<a href="${url}">perfdog链接</a></p>`;
          this.html_SP();
          let text = this.up_string + this.htmlValue2 + this.down_string;
          dispatchAddBug(store, {
            project: this.localProject,
            title: title,
            description: text,
            current_owner: this.basic_form.processed_by,
            originphase: this.basic_form.discovery_phase,
            severity: this.basic_form.degree,
            version_report: this.basic_form.discovered_version,
          });
          //     if(i==list.length-1){
          //   console.log(false_length)
          // }
        });
      });

      if (
        all_length.length != false_length.length &&
        false_length.length != 0
      ) {
        ElMessage.success({
          message: `<p>共提单${false_length.length}个：<a target="_blank" href="https://tapd.woa.com/tapd_fe/70086063/bug/list?page=1&confId=1070086063078555265">点击查看</a>`,
          showClose: true,
          type: "success",
          dangerouslyUseHTMLString: true,
        });
      }
      if (false_length.length == 0) {
        ElMessage.success({
          message: "没有问题提单",
          showClose: true,
          dangerouslyUseHTMLString: true,
          type: "success",
        });
      }
      if (all_length.length === false_length.length) {
        ElMessage.success({
          message: `<p>共提单${false_length.length}个：<a target="_blank" href="https://tapd.woa.com/tapd_fe/70086063/bug/list?page=1&confId=1070086063078555265">点击查看</a>`,
          showClose: true,
          dangerouslyUseHTMLString: true,
          type: "success",
        });
      }
    }
    if (this.form_problem === "按场景提单") {
      let false_length = [];
      let td_all = "";
      let numHead = "";
      let checkHead = "";
      this.problemList.forEach((v) => {
        numHead += `<td style="border:1px solid #d9d9d9;font-weight:bold">${this.problem_data[v]}</td>`;
      });
      this.checkedCities.forEach((v) => {
        checkHead += `<td style="border:1px solid #d9d9d9;font-weight:bold">${this.problem_data[v]}</td>`;
      });
      this.problemListEdit.forEach((v, index) => {
        let list = this.problem_data[v].res.filter((v) => v != "✔" && v != "-");

        // let title = this.device_name + "-" + v + "-" + this.form_problem;

        let text = "";
        let url = "";

        list.forEach((k, i) => {
          text += `<p>${i + 1}、${k}</p>`;
          url += `<p style="line-height:35px;font-size:14px">${v}:<a href=${this.problem_data[v].url}>perfdog链接</a></p>`;
        });
        if (text != "") {
          false_length.push(text);
          let title = `【Top客户端性能】【按场景分类】【${this.basic_form.title}】【${this.device_name}】${v}场景性能数据不达标`;
          this.htmlValue2 = `<table style="width:200px;border:1px solid #e2e7eb;border-collapse:collapse;font-size:14px; text-align: center;"><tr style="background:#5D99D5;border-width:0">${this.numHead}${this.checkHead}<td style="color:#fff">${v}</td></tr><tr style="border-width:0">${numHead}${checkHead}<td style="border:1px solid #d9d9d9;color:red;font-weight:bold">${text}</td></tr></table>${url}`;
          this.html_SP();

          dispatchAddBug(store, {
            project: this.localProject,
            title: title,
            description: this.up_string + this.htmlValue2 + this.down_string,
            current_owner: this.basic_form.processed_by,
            originphase: this.basic_form.discovery_phase,
            severity: this.basic_form.degree,
            version_report: this.basic_form.discovered_version,
          });
        }
        //  console.log(all_length,false_length)
      });
      if (
        this.problemListEdit.length != false_length.length &&
        false_length.length != 0
      ) {
        ElMessage.success({
          message: `<p>共提单${false_length.length}个：<a target="_blank" href="https://tapd.woa.com/tapd_fe/70086063/bug/list?page=1&confId=1070086063078555265">点击查看</a>`,
          showClose: true,
          dangerouslyUseHTMLString: true,
          type: "success",
        });
      }
      if (false_length.length == 0) {
        ElMessage.success({
          message: "没有问题提单",
          showClose: true,

          type: "success",
        });
      }
      if (this.problemListEdit.length == false_length.length) {
        ElMessage.success({
          message: `<p>共提单${false_length.length}个：<a target="_blank" href="https://tapd.woa.com/tapd_fe/70086063/bug/list?page=1&confId=1070086063078555265">点击查看</a>`,
          showClose: true,
          dangerouslyUseHTMLString: true,
          type: "success",
        });
      }
    }
    if (this.form_problem === "按机型提单") {
      let str = "";
      let num = 0;
      let false_length = [];
      let thead_all = "";
      let tbody_all = "";
      let scene_all = "";
      let url = "";
      let numHead = "";
      let checkHead = "";
      this.problemList.forEach((v) => {
        numHead += `<td style="border:1px solid #d9d9d9;font-weight:bold">${this.problem_data[v]}</td>`;
      });
      this.checkedCities.forEach((v) => {
        checkHead += `<td style="border:1px solid #d9d9d9;font-weight:bold">${this.problem_data[v]}</td>`;
      });
      this.problemListEdit.forEach((v, index) => {
        let list = this.problem_data[v].res.filter((v) => v != "✔" && v != "-");
        let text = "";

        list.forEach((k, i) => {
          text += `<p>${i + 1}、${k}</p>`;
          num++;
          str += `<p>${num}、${v}场景下${k}</p>`;
        });
        if (text != "") {
          url += `<p style="line-height:35px;font-size:14px">${v}:<a href=${this.problem_data[v].url}>perfdog链接</a></p>`;
          tbody_all += `<td style="border:1px solid #d9d9d9;color:red;font-weight:bold">${text}</td>`;
          thead_all += `<td style="border:1px solid #d9d9d9;color:#fff">${v}</td>`;
          scene_all += `${v}、`;
        }
        // list.forEach((k, i) => {
        //   num++;
        //   str += `<p>${num}、${v}场景下${k}</p>`;
        // });
      });
      if (str != "") {
        false_length.push(str);

        (this.htmlValue2 = `<table style="border:1px solid #e2e7eb;border-collapse:collapse;font-size:14px; text-align: center;"><tr style="background:#5D99D5;border-width:0">${this.numHead}${this.checkHead}${thead_all}</tr><tr style="border-width:0">${numHead}${checkHead}${tbody_all}</tr></table>${url}`),
          this.html_SP();

        dispatchAddBug(store, {
          project: this.localProject,
          title: `【Top客户端性能】【按机型分类】【${
            this.basic_form.title
          }】【${this.device_name}】多场景(${scene_all.substring(
            0,
            scene_all.length - 1
          )})性能数据不达标`,
          description: this.up_string + this.htmlValue2 + this.down_string,
          current_owner: this.basic_form.processed_by,
          originphase: this.basic_form.discovery_phase,
          severity: this.basic_form.degree,
          version_report: this.basic_form.discovered_version,
        });
      }
      if (false_length.length > 0) {
        ElMessage.success({
          message: `<p>共提单${false_length.length}个：<a target="_blank" href="https://tapd.woa.com/tapd_fe/70086063/bug/list?page=1&confId=1070086063078555265">点击查看</a>`,
          showClose: true,
          dangerouslyUseHTMLString: true,
          type: "success",
        });
      } else {
        ElMessage.success({
          message: "没有问题提单",
          showClose: true,

          type: "success",
        });
      }
    }

    this.htmlShow = true;
    this.btnName();
  }

  public editorOption = {
    theme: "snow", // 主题
    // debug: 'info',
    placeholder: "请输入其他说明",
    modules: {
      toolbar: {
        container: [
          ["bold", "italic", "underline", "strike"],
          // ["blockquote",],
          [{ header: 1 }, { header: 2 }],

          [{ script: "sub" }, { script: "super" }],

          [{ size: ["small", false, "large", "huge"] }],
          [{ header: [1, 2, 3, 4, 5, 6, false] }],
          [{ color: [] }, { background: [] }],

          ["link"],

          // ["clean", "link", "image"]
          // ['addBtn']
        ], // 自定义工具栏选项
      },
    },
  };

  public get modelList() {
    return readtopModelPerformance(store);
  }
  public get templatesData() {
    return readTopTemplatesData(store);
  }
  public get levelList() {
    return readtopLevelPerformance(store);
  }
  public get testerList() {
    return readtopTesterPerformance(store);
  }
  public htmlValue = "";
  public async deleteData() {
    await dispatchDeletetopPerformance(store, {
      project: this.localProject,
      id_list: this.checkList,
    });
    ElMessage.success({
      message: "删除成功",
      showClose: true,
      type: "success",
    });
    await dispatchGetTopPerformance(store, {
      project: this.localProject,
      page: this.current_page,
      size: this.record,
      label: this.form.label.join(";"),
      model: this.form.model.join(";"),
      level: this.form.level == "" ? "" : Number(this.form.level),
      tester: this.form.tester,
      project_name: this.form.project ? this.form.project : "",
      is_sub: 1,
    });
    this.get_all_performance.forEach((v) => {
      v.is_check = false;
    });
  }
  public downloadCsv1() {
    const response_data = dispatchUploadPerformanceTable(
      store,
      this.formTableData
    );
    response_data.then((value) => {
      var elink = document.createElement("a");
      elink.download = "问题汇总" + ".xlsx";
      elink.style.display = "none";
      var blob = new Blob([value], { type: "application/vnd.ms-excel" });
      elink.href = URL.createObjectURL(blob);
      document.body.appendChild(elink);
      elink.click();
      document.body.removeChild(elink);
    });
  }
  public async downloadCsv() {
    const response_data = dispatchDeepTopDownLoad(store, {
      project: Number(this.localProject),
      label: this.form.label.join(";"),
      model: this.form.model.join(";"),
      level: this.form.level,
      tester: this.form.tester,
      project_name: this.form.project,
      id_list: this.checkList,
    });
    response_data.then((value) => {
      var elink = document.createElement("a");
      elink.download = this.form.project ? this.form.project : "全部" + ".xls";
      elink.style.display = "none";
      var blob = new Blob([value], { type: "application/vnd.ms-excel" });
      elink.href = URL.createObjectURL(blob);
      document.body.appendChild(elink);
      elink.click();
      document.body.removeChild(elink);
    });
  }
  public checkList = [];
  public handleCheck(row, value) {
    this.checkList = [];
    if (row.length > 0) {
      this.get_all_performance.forEach((v) => {
        v.is_check = true;
        this.checkList.push(v.id);
      });
    } else {
      this.get_all_performance.forEach((v) => {
        v.is_check = false;
        this.checkList = [];
      });
    }
  }
  public form = {
    project: "",
    label: [],
    model: [],
    level: "",
    tester: "",
  };
  public dialogForm = {
    scene_id: "",
    is_valid: true,
    b_auto_collect: false,
    remark: "",
    UUID: "",
    task_record_id: "",
    task_group_index: "",
  };
  public beforeRemove(file) {
    let index_num = 0;
    this.fileList.forEach((v, index) => {
      if (v.uid == file.uid) {
        index_num = index;
      }
    });
    this.fileList.splice(index_num, 1);
  }
  public beforeUpload(file: any) {
    let extension = file.name.substring(file.name.lastIndexOf(".") + 1);
    let isLt2M = file.size / 1024 / 1024 < 50;
    if (["xls", "xlsx"].indexOf(extension) === -1) {
      ElMessage.error({
        message: "只能上传后缀是.xlsx/.xls的文件",
        showClose: true,
        type: "error",
      });
      (this.$refs["upload"] as any).clearFiles();
    }
    if (!isLt2M) {
      ElMessage.error({
        message: "上传文件大小不能超过50MB!",
        showClose: true,
        type: "error",
      });
      (this.$refs["upload"] as any).clearFiles();
    }
    return extension && isLt2M;
  }
  public beforeUploadTop(file: any) {
    let extension = file.name.substring(file.name.lastIndexOf(".") + 1);
    let isLt2M = file.size / 1024 / 1024 < 50;
    if (["xls", "xlsx"].indexOf(extension) === -1) {
      ElMessage.error({
        message: "只能上传后缀是.xlsx/.xls的文件",
        showClose: true,
        type: "error",
      });
      (this.$refs["uploadTop"] as any).clearFiles();
    }
    if (!isLt2M) {
      ElMessage.error({
        message: "上传文件大小不能超过50MB!",
        showClose: true,
        type: "error",
      });
      (this.$refs["uploadTop"] as any).clearFiles();
    }
    return extension && isLt2M;
  }
  public activeName = "first";
  public async UploadProblem(btn: string) {
    if (btn === "open") {
      this.dialogVisible1 = true;

      // this.formData = new FormData();
      // (this.$refs["upload"] as any)?.clearFiles();
    }
    if (btn === "no") {
      this.formData1 = new FormData();
      (this.$refs["uploadTop"] as any)?.clearFiles();
    }
    if (btn === "ok") {
      this.formData1.append("project", this.localProject);
      this.formTableData = this.formData1;
      this.formData1.append(
        "project_name",
        this.basic_value
          ? this.top_base_list.filter((v) => v.id == this.basic_value)[0]
              .project_name
          : ""
      );

      let b = (this as any).$message({
        //Message 消息提示
        message: "上传中",
        showClose: true,
        duration: 0,
      });

      await dispatchUploadPerformanceUpload(store, this.formData1);
      this.uploadShow = false;
      b.close();
      ElMessage.success({
        message: "数据上传成功",
        showClose: true,
        type: "success",
      });
      this.formData1 = new FormData();

      (this.$refs["uploadTop"] as any)?.clearFiles();

      this.dialogVisible1 = false;

      this.current_page = 1;
      this.courseSize = 10;
      this.checkedCities = ["默认画质"];

      //  this.linechangeData()

      // this.linechangeData()

      // this.formData = new FormData();
      // this.fileList = [];
      // (this.$refs["upload"] as any)?.clearFiles();
    }
  }
  // public open_Preload(){
  //   this.peload_show=true
  // }
  public project_name() {
    if (this.localProject === 17) {
      return "CFM地图探索冒烟";
    }
    if (this.localProject === 12) {
      return "逆战手游";
    }
    if (this.localProject === 12) {
      return "Top机型测试";
    }
  }
  public async submitUpload(btn: string) {
    if (btn === "open") {
      this.dialogVisible = true;
      this.dialogForm = {
        scene_id: "",
        is_valid: true,
        b_auto_collect: false,
        remark: "",
        UUID: "",
        task_record_id: "",
        task_group_index: "",
      };
      // this.formData = new FormData();
      // (this.$refs["upload"] as any)?.clearFiles();
    }
    if (btn === "no") {
      this.dialogForm1.project = "";
      this.dialogForm1.url = "";
      this.dialogForm = {
        scene_id: "",
        is_valid: true,
        b_auto_collect: false,
        remark: "",
        UUID: "",
        task_record_id: "",
        task_group_index: "",
      };
      this.formData = new FormData();
      (this.$refs["upload"] as any)?.clearFiles();
    }
    if (btn === "ok") {
      if (this.dialogForm1.project == "") {
        ElMessage.error({
          message: "请选择项目",
          showClose: true,
          type: "error",
        });
        return;
      } else {
        this.formData.append("project", this.localProject);
        this.formData.append("project_name", this.dialogForm1.project);
        this.formData.append("url", this.dialogForm1.url);
        this.fileList.forEach((item, index) => {
          this.formData.append("file", item);
        });

        this.checkList = [];
        this.current_page = 1;
        this.record = 16;

        this.form.label = [];
        this.form.model = [];
        this.form.level = "";
        this.form.tester = "";
        this.dialogVisible = false;
        this.uploadShow = true;
        let b = (this as any).$message({
          //Message 消息提示
          message: "上传中",
          showClose: true,
          duration: 0,
        });
        await dispatchUploadTopPerformance(store, this.formData);
        this.uploadShow = false;
        b.close();
        ElMessage.success({
          message: "数据上传成功",
          showClose: true,
          type: "success",
        });
        this.formData = new FormData();
        this.fileList = [];
        (this.$refs["upload"] as any)?.clearFiles();
      }
      await dispatchGetTopProjectPerformance(store, {
        project: this.localProject,
      });
      this.form.project =
        this.projectList.length > 0 ? this.projectList[0].project_name : "";
      await dispatchGetTopPerformance(store, {
        project: this.localProject,
        page: 1,
        size: this.record,
        label: "",
        model: "",
        level: "",
        tester: "",
        project_name: this.form.project ? this.form.project : "",
        is_sub: 1,
      });
      this.get_all_performance.forEach((v) => {
        v.is_check = false;
      });
    }
  }
  //  public IsValidChange(item){
  //    console.log(item)
  //  }
  public form_problem = "";
  public selectTableChange_top() {
    dispatchGetTopPerformanceList(store, {
      project: this.localProject,
      page: this.courseCurrentPage_top,
      size: this.top_size,
      project_id: this.top_project_old,
      model_name: this.top_project,
      version: this.top_version,
    });
  }
  public async selectTableChange(operation: any) {
    this.checkList = [];
    (this.current_page = operation == "paging" ? this.current_page : 1),
      (this.record = operation == "paging" ? this.record : 16);
    if (operation === "project") {
      dispatchGetTopMainLabelPerformance(store, {
        project: this.localProject,
        project_name: this.form.project,
      });
      this.form.label = [];
      // dispatchGetTopModelPerformance(store, {
      //  project: this.localProject,
      // });
      // dispatchGetTopLevelPerformance(store, {
      //  project: this.localProject,
      // });
      // dispatchGetTopTesterPerformance(store, {
      //  project: this.localProject,
      // });
    }

    await dispatchGetTopPerformance(store, {
      project: this.localProject,
      page: this.current_page,
      size: this.record,
      label: this.form.label.join(";"),
      model: this.form.model.join(";"),
      level: this.form.level == "" ? "" : Number(this.form.level),
      tester: this.form.tester,
      project_name: this.form.project ? this.form.project : "",
      is_sub: 1,
    });
    this.get_all_performance.forEach((v) => {
      v.is_check = false;
    });
  }
  public fileList = [];
  public fileList1 = [];

  public async UploadFile(param: any, file) {
    this.fileList.push(param.file);
    // this.formData.append('file',)
  }
  public async UploadFileTop(param: any, file) {
    this.formData1.append("file", param.file);
  }
  uploadVideoProcess(event, file, fileList) {
    this.progressFlag = true; // 显示进度条
    this.loadProgress = parseInt(event.percent); // 动态获取文件上传进度
    if (this.loadProgress >= 100) {
      this.loadProgress = 100;
      setTimeout(() => {
        this.progressFlag = false;
      }, 1000); // 一秒后关闭进度条
    }
  }

  public formData: any = new FormData();
  public formData1: any = new FormData();
  public formData2: any = new FormData();
  public formTableData: any = new FormData();
  public dialogVisible = false;
  public dialogVisible1 = false;
  public dialogVisible3 = false;
  public dialogVisible4 = false;
  public dialogVisible6 = false;
  public record = 16; //记录条数
  public get_url(url: string) {
    let new_url = url;
    if (url) {
      let url_arr = url.split("/");
      if (url_arr[2] !== "runmax.oa.com") {
        let current_herf = window.parent.location.href;
        let f = current_herf.split("/");
        let domain = f[2];
        url_arr[2] = domain;
        new_url = url_arr.join("/");
        return new_url;
      }
    }
    return url;
  }
  public indexMethod(index: any) {
    return index + 1 + (this.current_page - 1) * this.record;
  }
  public indexMethod1(index: any) {
    return index + 1 + (this.courseCurrentPage_top - 1) * this.top_size;
  }
  public indexMethod2(index: any) {
    return index + 1 + (this.peload_currentPage - 1) * this.peload_size;
  }
  public async onTableClear() {
    this.checkList = [];
    this.form.project = "";
    this.form.label = [];
    this.form.model = [];
    this.form.level = "";
    this.form.tester = "";
    this.current_page = 1;
    this.record = 16;
    await dispatchGetTopPerformance(store, {
      project: this.localProject,
      page: 1,
      size: this.record,
      label: "",
      model: "",
      level: "",
      tester: "",
      project_name: this.form.project ? this.form.project : "",
      is_sub: 1,
    });
    this.get_all_performance.forEach((v) => {
      v.is_check = false;
    });
  }
  public handleDetail(row, colume) {
    let d = row.label_name;
    this.$router.push({
      path: "/TopSubData",
      query: {
        ...this.$route.query,
        id_test: row.id_test,
        label_main: encodeURI(row.label_name),
      },
    });
  }
  public id_test = 0;
  public label_name = "";
  public async handleDetailProblem(row) {
    // this.id_test = row.id_test;
    if (this.checkList.length > 0) {
      this.current_page = 1;
      this.courseSize = 10;
      this.checkedCities = ["默认画质"];
      dispatchGetProblemSummay(store, {
        project: this.localProject,
        id_list: this.checkList,
        project_name: this.basic_value
          ? this.top_base_list.filter((v) => v.id == this.basic_value)[0]
              .project_name
          : "",
      });
      this.activeName = "thread";
      this.dialogVisible4 = false;
      //  this.linechangeData()
    } else {
      ElMessage.error({
        message: "请勾选数据",
        showClose: true,
        type: "error",
      });
      return;
    }
    // this.label_name = row.label_name;
    // dispatchGetProblemSummay(store, {
    //   project: this.localProject,
    //   id_list:this.checkList
    // });

    this.checkAll = false;
  }
  public uploadShow = false;
  public PerfFields = [
    // { label: "序号", prop: "index", width: 60 },
    { label: "测试时间", prop: "date", width: 180 },
    { label: "Label场景", prop: "label_name", width: 180 },
    { label: "分档信息", prop: "level", width: 100 },
    { label: "设备型号", prop: "model", width: 100 },
    // { label: "测试人员", prop: "tester", width: 100 },
    // { label: "CPU型号", prop: "cpu_model", width: 100 },
    // { label: "CPU核数", prop: "core_num", width: 100 },
    // { label: "GPU型号", prop: "gpu_model", width: 100 },
    // { label: "内存大小", prop: "ram", width: 100 },
    // { label: "系统版本", prop: "os", width: 100 },
    // { label: "CPU频率", prop: "cpu_freq", width: 100 },
    // { label: "CPU评分", prop: "cpu_score", width: 100 },
    // { label: "GPU评分", prop: "gpu_score", width: 100 },
    // { label: "屏幕类型", prop: "screen_type", width: 100 },
    // { label: "屏幕分辨率", prop: "resolution", width: 100 },
    // { label: "屏幕刷新率", prop: "refresh", width: 100 },
    // { label: "CPU位数", prop: "cpu_bits", width: 100 },
    // { label: "OpenglEs", prop: "OpenglEs", width: 100 },
    // { label: "用户量占比", prop: "user_percentage", width: 100 },
    // { label: "综合分", prop: "score", width: 100 },
    { label: "默认画质", prop: "picture_quality", width: 100 },
    { label: "avgFPS", prop: "avg_fps", width: 100 },
    { label: "FPS>18占有率(%)", prop: "fps_gt_18_pcnt", width: 100 },
    { label: "FPS>25占有率(%)", prop: "fps_gt_25_pcnt", width: 100 },
    { label: "平均PSS", prop: "avg_pss", width: 100 },
    { label: "峰值PSS", prop: "max_pss", width: 100 },
    { label: "avgCPU(%)", prop: "avg_cpu", width: 100 },
    { label: "CPU<90占有率(%)", prop: "cpu_lt_90_pcnt", width: 100 },
    { label: "Jank", prop: "jank", width: 100 },
    { label: "BigJank", prop: "big_jank", width: 100 },
    { label: "10min流量(kb)", prop: "min10_flow", width: 100 },
    { label: "cpu温度峰值(°C)", prop: "max_cpu_temp", width: 100 },
    { label: "cpu平均温度(°C)", prop: "cpu_temp", width: 100 },
    { label: "电池温度峰值(°C)", prop: "max_battery_temp", width: 100 },
    { label: "电池平均温度(°C)", prop: "battery_temp", width: 100 },
    { label: "温枪测温-开始温度(°C)", prop: "start_temp", width: 100 },
    { label: "cpu温度峰值-结束温度(°C)", prop: "end_temp", width: 100 },
    { label: "降频降帧", prop: "down_freq_down_frame", width: 100 },
    { label: "主观卡顿", prop: "caton", width: 100 },
    { label: "发热情况", prop: "fever", width: 100 },
    { label: "测试时长", prop: "duration", width: 100 },
    { label: "是否闪退", prop: "is_crash1", width: 100 },
    { label: "备注", prop: "remark", width: 100 },
  ];
  public getProjects(search?: string) {
    const projects: any[] = readMyProjects(store);
    return projects;
  }
  public peloadChange_top(data) {
    if (data) {
      this.peload_currentPage = 1;
    }
    dispatchGetTopPerformanceListAdvance(store, {
      project: this.localProject,
      page: this.peload_currentPage,
      size: this.peload_size,
      is_valid: 0,
      project_id: this.filterScript,
      version: this.topProjectVersion,
      test_time: this.test_time,
    });
  }
  public top_size = 10;
  public courseCurrentPage_top = 1;
  public peload_currentPage = 1;
  public peload_size = 10;
  public async linechangeData() {
    if (this.basic_value == "") {
      this.configuration_name = "";
      this.secondData();
    } else {
      this.configuration_name = this.top_base_list.filter(
        (v) => v.id == this.basic_value
      )[0].project_name;
      await dispatchGetTopBaselinesData(store, {
        id: this.basic_value,
        project: this.localProject,
      });
      this.baseline_data = [];
      this.baseline_data_fps = [];
      this.baseline_data_Picture = [];
      let setting = JSON.parse(readTopBaselinesData(store).settings);

      this.baseline_data.push(
        setting.stuck_baseline,
        setting.hot_baseline,
        setting.crash_baseline
      );
      this.baseline_data.forEach((v) => {
        v.no_pass_text = v.no_pass.join("、");
        v.pass_text = v.pass.join("、");
      });

      for (let i in setting.fps_baseline) {
        let list = [];

        for (let item in setting.fps_baseline[i]) {
          list.push({
            name: i,
            module: item,
            avgFps: setting.fps_baseline[i][item].AvgFPS,
            maxPss: setting.fps_baseline[i][item]["MaxPSS(MB)"],
            最高温度: setting.fps_baseline[i][item]["最高温度"],
          });
        }
        this.baseline_data_fps.push(list);
      }

      for (let i in setting.pss_baseline) {
        let list = [];
        for (let item in setting.pss_baseline[i]) {
          list.push({
            name: i,
            module: item,
            maxPss: setting.pss_baseline[i][item]["MaxPSS(MB)"],
          });
        }
        this.baseline_data_Picture.push(list);
      }
    }
  }
  public gameTypeList = [
    { label: "第一人称视角射击游戏", value: 1 },
    { label: "多人在线战术竞技游戏", value: 2 },
    { label: "角色扮演游戏", value: 3 },
    { label: "动作游戏", value: 4 },
    { label: "冒险游戏", value: 5 },
    { label: "动作冒险游戏", value: 6 },
    { label: "策略游戏", value: 7 },
    { label: "模拟类角色扮演游戏", value: 8 },
    { label: "即时战略游戏", value: 9 },
    { label: "格斗游戏", value: 10 },
    { label: "射击类游戏", value: 11 },
    { label: "第三人称视角射击游戏", value: 12 },
    { label: "益智类游戏", value: 13 },
    { label: "体育竞技类游戏", value: 14 },
    { label: "竞速游戏", value: 15 },
    { label: "卡片游戏", value: 16 },
    { label: "桌面游戏", value: 17 },
    { label: "音乐游戏", value: 18 },
    { label: "手机游戏", value: 19 },
    { label: "泥巴游戏", value: 20 },
  ];
  public dataTypeList = [
    { label: "竞品游戏数据", value: 1 },
    { label: "测试游戏数据/迭代游戏数据", value: 2 },
  ];

  public async lineChange() {
    this.linechangeData();
    // if(this.basic_value==''){
    //    this.configuration_name=''
    // this.secondData()
    // }else{
    //   this.configuration_name=this.top_base_list.filter(v=>v.id==this.basic_value)[0].project_name
    //    await dispatchGetTopBaselinesData(store,{
    //   id:this.basic_value,
    //   project:this.localProject
    // })
    // this.baseline_data=[]
    // this.baseline_data_fps=[]
    // this.baseline_data_Picture=[]
    // let setting = JSON.parse(readTopBaselinesData(store).settings);
    // console.log(setting)
    //    this.baseline_data.push(
    //     setting.stuck_baseline,
    //     setting.hot_baseline,
    //     setting.crash_baseline
    //   );
    //       this.baseline_data.forEach((v) => {
    //     v.no_pass_text = v.no_pass.join("、");
    //     v.pass_text = v.pass.join("、");
    //   });

    //   console.log(setting.fps_baseline)
    //    let filtList=['4档','5档']

    //   for (let i in setting.fps_baseline) {
    //     let list = [];

    //     for (let item in setting.fps_baseline[i]) {

    //       list.push({
    //         name: i,
    //         module: item,
    //         avgFps: setting.fps_baseline[i][item].AvgFPS,
    //         maxPss: setting.fps_baseline[i][item]["MaxPSS(MB)"],
    //       });
    //     }
    //     this.baseline_data_fps.push(list);

    //   }
    //    console.log(this.baseline_data_fps)
    //   for (let i in setting.pss_baseline) {
    //     let list = [];
    //     for (let item in setting.pss_baseline[i]) {
    //       list.push({
    //         name: i,
    //         module: item,
    //         maxPss: setting.pss_baseline[i][item]["MaxPSS(MB)"],
    //       });
    //     }
    //     this.baseline_data_Picture.push(list);
    //   }
    // }
  }
  public topProjectVersion = "";
  public baseline_data_fps = [];
  public baseline_data_Picture = [];
  public iframeWin = "";
  public cellMerge({ row, column, rowIndex, columnIndex }) {
    if (columnIndex === 0) {
      const _row = this.spanArr[rowIndex];
      const _col = _row > 0 ? 1 : 0;

      return {
        rowspan: _row,
        colspan: _col,
      };
    }
  }
  public spanArr = [];
  public pos = 0;
  public getSpanArr(data) {
    for (var i = 0; i < data.length; i++) {
      if (i === 0) {
        this.spanArr.push(1);
        this.pos = 0;
      } else {
        // 判断当前元素与上一个元素是否相同
        if (data[i].name === data[i - 1].name) {
          this.spanArr[this.pos] += 1;
          this.spanArr.push(0);
        } else {
          this.spanArr.push(1);
          this.pos = i;
        }
      }
    }
  }
  public get checkHead() {
    let str = "";
    this.checkedCities.forEach((v) => {
      str += `<td style="border:1px solid #d9d9d9;color:#fff">${v}</td>`;
    });
    return str;
  }
  public get numHead() {
    let str = "";
    this.problemList.forEach((v) => {
      str += `<td style="border:1px solid #d9d9d9;color:#fff">${v}</td>`;
    });
    return str;
  }
  public btnName() {
    if (this.htmlShow == true) {
      this.btn_name = "编辑";
    }
    if (this.htmlShow == false) {
      this.btn_name = "保存";
    }
    // if(this.htmlShow==false&&this.basic_form.value==''){
    //   this.btn_name='创建'
    // }
  }
  public async mounted() {
    dispatchGetTopPerformanceList(store, {
      project: this.localProject,
      page: this.courseCurrentPage_top,
      size: this.top_size,
      project_id: this.filterScript,
      model_name: this.top_project,
      version: this.top_version,
    });
    dispatchGetTopProjectScenes(store, {
      project: this.localProject,
    });
    dispatchGetTopOptions(store, {
      project: this.localProject,
    });
    this.htmlValue =
      '<p style="line-height:35px;font-size:14px">游戏客户端版本号:</p><p style="line-height:35px;font-size:14px">测试服务器:</p><p style="line-height:35px;font-size:16px;font-weight:bold;">【操作步骤】</p><p style="line-height:35px;font-size:14px">1、使用设备链接perfdog工具</p><p style="line-height:35px;font-size:14px">2、根据性能用例进行性能数据采集</p><p style="line-height:35px;font-size:14px">3、操作过程中查看性能数据和游戏表现</p><p style="line-height:35px;font-size:16px;font-weight:bold;">【问题描述】</p><p style="line-height:35px;font-size:14px">自动生成</p><p style="line-height:35px;font-size:16px;font-weight:bold;">【在线文档】</p><p style="line-height:35px;font-size:16px;font-weight:bold;">文档链接:</p>';
    this.basic_form.title = this.project_name();
    this.btnName();
    // console.log(this.formTableData.get("file"));
    await dispatchGetProjectDetail(store, {
      id: this.localProject,
      project: this.localProject,
    });
    dispatchGetTopTemplates(store, {
      project: this.localProject,
    });
    dispatchGetTopBaselines(store, {
      project: this.localProject,
    });

    this.secondData();
    // this.activeName = "thread";
    // this.dialogVisible1=true
    let list = [
      "stuck_baseline",
      "hot_baseline",
      "crash_baseline",
      "fps_baseline",
      "pss_baseline",
    ];

    // let setting = JSON.parse(readProjectDetail(store).rule_settings);

    // console.log(JSON.parse(readProjectDetail(store).rule_settings));
    // this.baseline_data_Picture.forEach((item) => {
    //   this.getSpanArr(item);
    // });
    // console.log(this.baseline_data_fps);
    this.baseline_data_fps.forEach((item) => {
      this.getSpanArr(item);
    });

    // await dispatchGetMyProjects(store);
    await dispatchGetTopProjectPerformance(store, {
      project: this.localProject,
    });
    this.form.project =
      this.projectList.length > 0 ? this.projectList[0].project_name : "";

    await dispatchGetTopMainLabelPerformance(store, {
      project: this.localProject,
      project_name: this.form.project,
    });
    dispatchGetTopPerformance(store, {
      project: this.localProject,
      page: this.current_page,
      size: this.record,
      label: "",
      model: "",
      level: "",
      tester: "",
      project_name: this.form.project ? this.form.project : "",
      is_sub: 1,
    });
    dispatchGetTopModelPerformance(store, {
      project: this.localProject,
    });
    dispatchGetTopLevelPerformance(store, {
      project: this.localProject,
    });
    dispatchGetTopTesterPerformance(store, {
      project: this.localProject,
    });
  }
  public dialogForm1 = {
    project: "",
    url: "",
  };
  public testCliak() {
    console.log(this.baseline_data);
  }

  public async subjectivityChange(item, type, v) {
    this.problem_item = "";
    this.problem_i = "";
    this.problem_column_i = "";
    let setting = JSON.parse(readProjectDetail(store).rule_settings);

    if (item === "主观卡顿") {
      setting.stuck_baseline[type] = v.split("、");
    }
    if (item === "主观发热") {
      setting.hot_baseline[type] = v.split("、");
    }
    if (item === "是否闪退") {
      setting.crash_baseline[type] = v.split("、");
    }

    const Receiver = {
      project_key: readProjectDetail(store).project_key,
      project: this.localProject,
      report_settings: readProjectDetail(store).report_settings,
      rule_settings: JSON.stringify(setting),
    };
    await dispatchUpdateProject(store, {
      id: readProjectDetail(store).id as number,
      project: Receiver,
    });
    await dispatchGetProjectDetail(store, {
      id: this.localProject,
      project: this.localProject,
    });
    if (this.checkList.length > 0) {
      await dispatchGetProblemSummay(store, {
        project: this.localProject,
        id_list: this.checkList,
        project_name: this.basic_value
          ? this.top_base_list.filter((v) => v.id == this.basic_value)[0]
              .project_name
          : "",
      });
    } else {
      ElMessage.error({
        message: "请勾选数据",
        showClose: true,
        type: "error",
      });
    }
  }
  public upload_thead = [
    { lable: "设备名称", value: "model_name" },
    { lable: "设备型号", value: "model" },
    { lable: "分档信息", value: "level" },
    { lable: "厂商", value: "oem" },
    { lable: "用户占比", value: "user_percentage" },
    { lable: "CPU型号", value: "cpu_model" },
    { lable: "系统版本", value: "os" },
    { lable: "内存大小(GB)", value: "ram" },
    { lable: "CPU评分", value: "cpu_score" },
    { lable: "GPU评分", value: "gpu_score" },
    { lable: "屏幕类型", value: "screen_type" },
    { lable: "分辨率", value: "resolution" },
    { lable: "屏幕刷新率", value: "refresh" },
    { lable: "OpenglEs", value: "OpenglEs" },
    { lable: "测试场景", value: "scene" },
    { lable: "测试日期", value: "date" },
    { lable: "AvgFPS风险", value: "avg_fps_risk" },
    { lable: "MaxPSS风险", value: "max_pss_risk" },
    { lable: "FPS与基准差值", value: "fps_baseline_diff" },
    { lable: "PSS与基准差值", value: "pss_baseline_diff" },
    { lable: "perfdog 链接", value: "url" },
    { lable: "默认画质", value: "picture_quality" },
    { lable: "默认帧率", value: "default_framerate" },
    { lable: "默认画质截图", value: "screenshot" },
    { lable: "Avg FPS(帧/s)", value: "avg_fps" },
    { lable: "机型分布", value: "distribution" },
    { lable: "FPS>=18占有率(%)", value: "fps_gt_18_pcnt" },

    { lable: "FPS>=25占有率(%)", value: "fps_gt_25_pcnt" },
    { lable: "平均内存", value: "avg_pss" },
    { lable: "峰值内存", value: "max_pss" },
    { lable: "平均CPU", value: "avg_cpu" },
    { lable: "CPU<90%占比", value: "cpu_lt_90_pcnt" },
    { lable: "Jank(卡顿/10min)", value: "jank" },
    { lable: "BigJank(卡顿/10min)", value: "big_jank" },
    { lable: "Avg(Power) [mW]", value: "avg_power" },
    { lable: "10min流量(kb)", value: "min10_flow" },
    { lable: "开始温度", value: "start_temp" },
    { lable: "结束最高温度", value: "end_temp" },
    { lable: "主观卡顿", value: "主观卡顿" },
    { lable: "卡顿详情", value: "caton_detail" },
    { lable: "测试时长", value: "duration" },
    { lable: "是否闪退", value: "is_crash" },
    { lable: "备注", value: "remark " },
    // {lable:'主观发热',value:'fever'},
    // {lable:'主观发热',value:'fever'},
  ];

  public checkChange(item) {
    if (item.is_check == true) {
      this.checkList.push(item.id);
    } else {
      this.checkList = this.checkList.filter((v) => v != item.id);
    }
  }
  public get readPerformancePageList() {
    return readtopPerformance(store);
  }

  public get problemData() {
    let list = [];
    list = readUploadTopPerformanceLoad(store);
    list.forEach((v) => {
      v["提单状态"] = 0;
    });
    // list=[
    //   {
    //     "设备序号": 1,
    //     "设备型号": "v1986a",
    //     "设备名称": "iQOO Z1",
    //     "设备品牌": "VIVO",
    //     "CPU型号": "MT6889Z",
    //     "CPU核数": "8",
    //     "GPU型号": "Mali-G77MC9",
    //     "内存大小": "8",
    //     "系统版本": "11",
    //     "CPU频率": "2.6",
    //     "CPU评分": "587.21",
    //     "GPU评分": "526.73",
    //     "屏幕类型": "全面屏，右上挖孔屏",
    //     "屏幕分辨率": "2408*1080",
    //     "屏幕刷新率": "144",
    //     "CPU位数": "64",
    //     "OpenglEs": "3.2",
    //     "TKMB号": "",
    //     "设备所在地": "",
    //     "数量": "",
    //     "用户量占比": "",
    //     "综合分": "",
    //     "测试时间": "2023-05-23",
    //     "分档信息": "1档",
    //     "默认画质": "",
    //     "新手1": [
    //         "✔"
    //     ],
    //     "新手2": [
    //         "✔"
    //     ],
    //     "爆破1": [
    //         "✔"
    //     ],
    //     "爆破2": [
    //         "✔"
    //     ],
    //     "超能进阶1": [
    //         "✔"
    //     ],
    //     "超能进阶2": [
    //         "✔"
    //     ]
    // },
    //   {
    //     "设备序号": 2,
    //     "设备型号": "v2073a",
    //     "设备名称": "iQOO Z3",
    //     "设备品牌": "VIVO",
    //     "CPU型号": "SM7250-AC",
    //     "CPU核数": "8",
    //     "GPU型号": "Adreno620",
    //     "内存大小": "8",
    //     "系统版本": "11",
    //     "CPU频率": "2.8",
    //     "CPU评分": "493.75",
    //     "GPU评分": "365",
    //     "屏幕类型": "全面屏，水滴屏",
    //     "屏幕分辨率": "2408*1080",
    //     "屏幕刷新率": "120",
    //     "CPU位数": "64",
    //     "OpenglEs": "3.2",
    //     "TKMB号": "",
    //     "设备所在地": "",
    //     "数量": "",
    //     "用户量占比": "",
    //     "综合分": "",
    //     "测试时间": "2023-05-23",
    //     "分档信息": "2档",
    //     "默认画质": "",
    //     "新手1": [
    //         "-"
    //     ],
    //     "新手2": [
    //         "✔"
    //     ],
    //     "爆破1": [
    //         "✔"
    //     ],
    //     "爆破2": [
    //         "✔"
    //     ],
    //     "超能进阶1": [
    //         "✔"
    //     ],
    //     "超能进阶2": [
    //         "✔"
    //     ]
    // },
    // {
    //     "设备序号": 3,
    //     "设备型号": "oppo r9m;oppo r9tm;oppo r9km;oppo r9t",
    //     "设备名称": "OPPO R9",
    //     "设备品牌": "OPPO",
    //     "CPU型号": "MT6755",
    //     "CPU核数": "8",
    //     "GPU型号": "Mali-T860MP2",
    //     "内存大小": "4",
    //     "系统版本": "5.1",
    //     "CPU频率": "1.95",
    //     "CPU评分": "121.16",
    //     "GPU评分": "70.37",
    //     "屏幕类型": "普通屏",
    //     "屏幕分辨率": "1920*1080",
    //     "屏幕刷新率": "60",
    //     "CPU位数": "64",
    //     "OpenglEs": "3.2",
    //     "TKMB号": "",
    //     "设备所在地": "",
    //     "数量": "",
    //     "用户量占比": "",
    //     "综合分": "",
    //     "测试时间": "2023-05-22",
    //     "分档信息": "3档",
    //     "默认画质": "",
    //     "新手1": [
    //         "✔"
    //     ],
    //     "新手2": [
    //         "-","MaxPSS超标(1644)"
    //     ],
    //     "爆破1": [
    //         "1.MaxPSS超标(1644)"
    //     ],
    //     "爆破2": [
    //         "1.MaxPSS超标(1755)"
    //     ],
    //     "超能进阶1": [
    //         "1.MaxPSS超标(1541)"
    //     ],
    //     "超能进阶2": [
    //         "1.MaxPSS超标(1656)",
    //         "2.aPSS超标(1656)"
    //     ]
    // },
    // {
    //     "设备序号": 4,
    //     "设备型号": "pgbm10",
    //     "设备名称": "OPPO Reno8",
    //     "设备品牌": "OPPO",
    //     "CPU型号": "MT6893Z",
    //     "CPU核数": "8",
    //     "GPU型号": "Mali-G77MC9",
    //     "内存大小": "8",
    //     "系统版本": "12",
    //     "CPU频率": "3",
    //     "CPU评分": "634.65",
    //     "GPU评分": "526.82",
    //     "屏幕类型": "全面屏，左上挖孔屏",
    //     "屏幕分辨率": "2400*1080",
    //     "屏幕刷新率": "90",
    //     "CPU位数": "64",
    //     "OpenglEs": "3.2",
    //     "TKMB号": "",
    //     "设备所在地": "",
    //     "数量": "",
    //     "用户量占比": "",
    //     "综合分": "",
    //     "测试时间": "2023-05-23",
    //     "分档信息": "1档",
    //     "默认画质": "",
    //     "新手1": [
    //         "✔"
    //     ],
    //     "新手2": [
    //         "✔"
    //     ],
    //     "爆破1": [
    //         "✔"
    //     ],
    //     "爆破2": [
    //         "✔"
    //     ],
    //     "超能进阶1": [
    //         "✔"
    //     ],
    //     "超能进阶2": [
    //         "✔"
    //     ]
    // },
    //     {
    //     "设备序号": 6,
    //     "设备型号": "m2102k1c",
    //     "设备名称": "小米11 Ultra",
    //     "设备品牌": "小米",
    //     "CPU型号": "SM8350",
    //     "CPU核数": "8",
    //     "GPU型号": "Adreno660",
    //     "内存大小": "12",
    //     "系统版本": "11",
    //     "CPU频率": "2.84",
    //     "CPU评分": "697.22",
    //     "GPU评分": "706.92",
    //     "屏幕类型": "全面屏，左上挖孔屏，曲面屏",
    //     "屏幕分辨率": "3200*1440",
    //     "屏幕刷新率": "120",
    //     "CPU位数": "64",
    //     "OpenglEs": "3.2",
    //     "TKMB号": "",
    //     "设备所在地": "",
    //     "数量": "",
    //     "用户量占比": "",
    //     "综合分": "",
    //     "测试时间": "2023-05-23",
    //     "分档信息": "1档",
    //     "默认画质": "",
    //     "新手1": [
    //         "1.AvgFPS不达标(56.6)"
    //     ],
    //     "新手2": [
    //         "1.AvgFPS不达标(58.7)"
    //     ],
    //     "爆破1": [
    //         "1.AvgFPS不达标(56.5)"
    //     ],
    //     "爆破2": [
    //         "1.AvgFPS不达标(57.3)"
    //     ],
    //     "超能进阶1": [
    //         "1.AvgFPS不达标(57.8)"
    //     ],
    //     "超能进阶2": [
    //         "1.AvgFPS不达标(56.1)"
    //     ]
    // },
    // ]

    return list;
  }
  public problem_item = "";
  public problem_i = "";
  public problem_column_i = "";
  public editOpen(item, i, b) {
    this.problem_item = item;
    this.problem_i = i;
    this.problem_column_i = b;
  }
  public async inputChange(type, module, name, price) {
    this.problem_item = "";
    this.problem_i = "";
    this.problem_column_i = "";
    let setting = JSON.parse(readProjectDetail(store).rule_settings);
    if (type != "") {
      if (type == "MaxPSS(MB)_picture") {
        setting.pss_baseline[name][module]["MaxPSS(MB)"] = price;
        const Receiver = {
          project_key: readProjectDetail(store).project_key,
          project: this.localProject,
          report_settings: readProjectDetail(store).report_settings,
          rule_settings: JSON.stringify(setting),
        };
        await dispatchUpdateProject(store, {
          id: readProjectDetail(store).id as number,
          project: Receiver,
        });
        await dispatchGetProjectDetail(store, {
          id: this.localProject,
          project: this.localProject,
        });
      } else {
        setting.fps_baseline[name][module][type] = price;
        const Receiver = {
          project_key: readProjectDetail(store).project_key,
          project: this.localProject,
          report_settings: readProjectDetail(store).report_settings,
          rule_settings: JSON.stringify(setting),
        };
        await dispatchUpdateProject(store, {
          id: readProjectDetail(store).id as number,
          project: Receiver,
        });
        await dispatchGetProjectDetail(store, {
          id: this.localProject,
          project: this.localProject,
        });
      }

      if (this.checkList.length > 0) {
        await dispatchGetProblemSummay(store, {
          project: this.localProject,
          id_list: this.checkList,
          project_name: this.basic_value
            ? this.top_base_list.filter((v) => v.id == this.basic_value)[0]
                .project_name
            : "",
        });
      }
    }
  }
  public inputBlur() {
    this.problem_item = "";
    this.problem_i = "";
    this.problem_column_i = "";
  }
  public device_name = "";
  public problem_data = {};
  public submitUnit(item) {
    this.problem_item = "";
    this.problem_i = "";
    this.problem_column_i = "";
    this.device_name = item["设备名称"];
    this.problem_data = item;

    this.dialogVisible3 = true;
  }
  public quilBtn() {
    let n = this.htmlValue.indexOf("述");
  }

  public addProBlem(type) {
    if (type === "ok") {
      this.dialogVisible3 = false;
      //  this.htmlValue='<p style="line-height:35px;">游戏客户端版本号:</p><p style="line-height:35px">测试服务器:</p><p style="line-height:35px">【操作步骤】</p><p style="line-height:35px">1、使用设备链接perfdog工具</p><p style="line-height:35px">2、根据性能用例进行性能数据采集</p><p style="line-height:35px">3、操作过程中查看性能数据和游戏表现</p><p style="line-height:35px">【问题描述】</p><p style="line-height:35px">【在线描述】</p><p style="line-height:35px">文档链接:<a href="gggg">2222</a></p>'
      this.activeName = "fourth";
      // if (this.form_problem === "按问题提单") {
      //   let all_length = [];
      //   let false_length = [];
      //   this.problemListEdit.forEach((v, index) => {
      //     let list = this.problem_data[v].res.filter((v) => v != "✔" && v != "-");
      //     this.problem_data[v].res.forEach((i) => {
      //       all_length.push(i);
      //     });
      //     let url=''
      //     if(list){
      //           url=this.problem_data[v].url
      //     }
      //     list.forEach((k, i) => {
      //       index++;
      //       false_length.push(k);
      //       let title = this.device_name + "-" + v + "-" + this.form_problem;
      //       // let text = `<p>${v}场景下${k}<p>`;
      //       this.htmlValue2=`<p style="line-height:35px">游戏客户端版本号:</p><p style="line-height:35px">测试服务器:</p><p style="line-height:35px">【操作步骤】</p><p style="line-height:35px">1、使用设备链接perfdog工具</p><p style="line-height:35px">2、根据性能用例进行性能数据采集</p><p sstyle="line-height:35px">3、操作过程中查看性能数据和游戏表现</p><p style="line-height:35px">【问题描述】</p><p><table style="width:200px;border:1px solid #e2e7eb;border-collapse;collapse;font-size:14px; text-align: center;"><tr style="background:#5D99D5;border-width:0"><td style="color:#fff">${v}</td></tr><tr style="border-width:0"><td style="color:red;font-weight:bold">${k}</td></tr></table></p><p>${v}:<a href="${url}">pefdog链接</a></p><p style="line-height:35px">【在线文档】</p><p style="line-height:35px">文档链接:</p>`
      //       let text =   this.htmlValue2;
      //       dispatchAddBug(store, {
      //         project: this.localProject,
      //         title: title,
      //         description: text,
      //       });
      //     });
      //   });
      //   console.log(all_length, false_length);
      //   if (
      //     all_length.length != false_length.length &&
      //     false_length.length != 0
      //   ) {
      //     ElMessage.success({
      //       message: `<p>共提单${false_length.length}个：<a target="_blank" href="https://tapd.woa.com/tapd_fe/70086063/bug/list?page=1&confId=1070086063078555265">点击查看</a>`,
      //       showClose: true,
      //       type: "success",
      //       dangerouslyUseHTMLString: true,
      //     });
      //   }
      //   if (false_length.length == 0) {
      //     ElMessage.success({
      //       message: "没有问题提单",
      //       showClose: true,
      //       dangerouslyUseHTMLString: true,
      //       type: "success",
      //     });
      //   }
      //   if (all_length.length === false_length.length) {
      //     ElMessage.success({
      //       message: `<p>共提单${false_length.length}个：<a target="_blank" href="https://tapd.woa.com/tapd_fe/70086063/bug/list?page=1&confId=1070086063078555265">点击查看</a>`,
      //       showClose: true,
      //       dangerouslyUseHTMLString: true,
      //       type: "success",
      //     });
      //   }
      // }
      // if (this.form_problem === "按场景提单") {
      //   let false_length = [];
      //   let td_all=''
      //   this.problemListEdit.forEach((v, index) => {
      //     let list = this.problem_data[v].res.filter((v) => v != "✔" && v != "-");
      //     console.log(list);

      //     let title = this.device_name + "-" + v + "-" + this.form_problem;
      //     let text = "";

      //     list.forEach((k, i) => {
      //       text += `<p>${i + 1}、${k}</p>`;

      //     });
      //     if (text != "") {
      //         this.htmlValue2=`<table style="width:200px;border:1px solid #e2e7eb;border-collapse;collapse;font-size:14px; text-align: center;"><tr style="background:#5D99D5;border-width:0"><td style="color:#fff">${v}</td></tr><tr style="border-width:0"><td style="color:red;font-weight:bold">${text}</td></tr></table>`
      //       dispatchAddBug(store, {
      //         project: this.localProject,
      //         title: title,
      //         description: this.htmlValue2=`<table style="width:200px;border:1px solid #e2e7eb;border-collapse;collapse;font-size:14px; text-align: center;"><tr style="background:#5D99D5;border-width:0"><td style="color:#fff">${v}</td></tr><tr style="border-width:0"><td style="color:red;font-weight:bold">${text}</td></tr></table>`,
      //       });
      //       false_length.push(text);
      //     }
      //     //  console.log(all_length,false_length)
      //   });
      //   if (
      //     this.problemListEdit.length != false_length.length &&
      //     false_length.length != 0
      //   ) {
      //     ElMessage.success({
      //       message: `<p>共提单${false_length.length}个：<a target="_blank" href="https://tapd.woa.com/tapd_fe/70086063/bug/list?page=1&confId=1070086063078555265">点击查看</a>`,
      //       showClose: true,
      //       dangerouslyUseHTMLString: true,
      //       type: "success",
      //     });
      //   }
      //   if (false_length.length == 0) {
      //     ElMessage.success({
      //       message: "没有问题提单",
      //       showClose: true,

      //       type: "success",
      //     });
      //   }
      //   if (this.problemListEdit.length == false_length.length) {
      //     ElMessage.success({
      //       message: `<p>共提单${false_length.length}个：<a target="_blank" href="https://tapd.woa.com/tapd_fe/70086063/bug/list?page=1&confId=1070086063078555265">点击查看</a>`,
      //       showClose: true,
      //       dangerouslyUseHTMLString: true,
      //       type: "success",
      //     });
      //   }
      // }
      // if (this.form_problem === "按机型提单") {
      //   let str = "";
      //   let num = 0;
      //   let false_length = [];
      //   let thead_all=''
      //   let tbody_all=''
      //   let url=''
      //   this.problemListEdit.forEach((v, index) => {
      //     let list = this.problem_data[v].res.filter((v) => v != "✔" && v != "-");
      //     let text = "";

      //     list.forEach((k, i) => {
      //       text += `<p>${i + 1}、${k}</p>`;
      //        num++;
      //       str += `<p>${num}、${v}场景下${k}</p>`;

      //     });
      //    if(text!=''){
      //      url+=`<p>${v}:<a href=${this.problem_data[v].url}>perfdog链接</a></p>`
      //      tbody_all+=`<td style="border:1px solid #d9d9d9;color:red;font-weight:bold"">${text}</td>`
      //      thead_all+=`<td style="border:1px solid #d9d9d9;color:#fff">${v}</td>`
      //    }
      //     // list.forEach((k, i) => {
      //     //   num++;
      //     //   str += `<p>${num}、${v}场景下${k}</p>`;
      //     // });
      //   });
      //   if (str != "") {
      //     false_length.push(str);
      //     this.htmlValue2=`<table style="border:1px solid #e2e7eb;border-collapse:collapse;font-size:14px; text-align: center;"><tr style="background:#5D99D5;border-width:0">${thead_all}</tr><tr style="border-width:0">${tbody_all}</tr></table>${url}`,
      //     dispatchAddBug(store, {
      //       project: this.localProject,
      //       title: this.device_name + "-" + this.form_problem,
      //       description: `<table style="border:1px solid #e2e7eb;border-collapse;collapse;font-size:14px; text-align: center;"><tr style="background:#5D99D5;border-width:0">${thead_all}</tr><tr style="border-width:0">${tbody_all}</tr></table>`,
      //     });
      //   }
      //   if (false_length.length > 0) {
      //     ElMessage.success({
      //       message: `<p>共提单${false_length.length}个：<a target="_blank" href="https://tapd.woa.com/tapd_fe/70086063/bug/list?page=1&confId=1070086063078555265">点击查看</a>`,
      //       showClose: true,
      //       dangerouslyUseHTMLString: true,
      //       type: "success",
      //     });
      //   } else {
      //     ElMessage.success({
      //       message: "没有问题提单",
      //       showClose: true,

      //       type: "success",
      //     });
      //   }
      // }
    }
  }
  public get problem_option() {
    return ["按问题提单", "按场景提单", "按机型提单"];
  }
  public editText(item, i, columnIndex, type) {
    if (type == "text") {
      if (
        item == this.problem_item &&
        i == this.problem_i &&
        columnIndex == this.problem_column_i
      ) {
        return false;
      } else {
        return true;
      }
    } else {
      if (
        item == this.problem_item &&
        i == this.problem_i &&
        columnIndex == this.problem_column_i
      ) {
        return true;
      } else {
        return false;
      }
    }
  }
  public down_string = "";
  public up_string = "";
  public html_SP() {
    let c = this.htmlValue.split("<p");
    let new_arry = c.filter((v) => v != "");
    let up_string = "";
    let down_string = "";
    let down_new = [];
    let up = [];
    let down = [];
    if (new_arry.some((v, index) => v.indexOf("问题描述") != -1)) {
      let html_table_index = new_arry.findIndex(
        (v) => v.indexOf("问题描述") != -1
      );
      up = new_arry.filter((v, index) => index <= html_table_index);
      down = new_arry.filter((v, index) => index > html_table_index);

      up.forEach((v) => {
        up_string += "<p" + v;
      });
      down_new = down.filter((v) => v.indexOf("自动生成") == -1);
      // console.log(down_new)
      down_new.forEach((v) => {
        down_string += "<p" + v;
      });
      this.down_string = down_string;
      this.up_string = up_string;
    } else {
      let x = new_arry.filter((v) => v.indexOf("自动生成") == -1);

      x.forEach((v) => {
        up_string += "<p" + v;
      });
      this.up_string = up_string;
      this.down_string = "";
      this.htmlValue2 = "";
    }

    // down_new=down.filter(v=>v.indexOf('自动生成')==-1)
    // down_new.forEach(v=>{
    //   down_string+='<p'+v
    // })
  }
  public text_messages = [];
  public checkAll = false;
  public isIndeterminate = true;
  public checkedCities = [];
  public messages = [];
  public get problemList() {
    let list = [];
    if (this.problemData.length > 0) {
      let theadKey = Object.keys(this.problemData[0]);
      theadKey.indexOf("默认画质");
      list = theadKey.filter((v, i) => i < theadKey.indexOf("设备品牌"));
    }

    return list;
  }
  public get messagesList_thead() {
    let list = [];
    if (this.problemData.length > 0) {
      let theadKey = Object.keys(this.problemData[0]);
      theadKey.indexOf("默认画质");
      list = theadKey.filter(
        (v, i) =>
          i >= theadKey.indexOf("设备品牌") && i <= theadKey.indexOf("默认画质")
      );
    }
    console.log(list);
    return list;
  }
  public handleCheckAllChange(value) {
    if (value == true) {
      this.checkedCities = this.messagesList_thead;
      this.isIndeterminate = false;
    } else {
      this.checkedCities = [];
    }
  }
  public handleCheckedCitiesChange(value) {
    const checkedCount = value.length;
    this.checkAll = checkedCount === this.messagesList_thead.length;
    this.isIndeterminate =
      checkedCount > 0 && checkedCount < this.messagesList_thead.length;
  }
  // public get messagesList_thead() {
  //   let list = [];
  //   if (this.problemData.length > 0) {
  //     let theadKey = Object.keys(this.problemData[0]);
  //     theadKey.indexOf("默认画质");
  //     list = theadKey.filter((v, i) => i <= theadKey.indexOf("GPU评分")&&i>=theadKey.indexOf("设备品牌"));
  //   }
  //   return list;
  // }
  public get problemListEdit() {
    let list = [];
    if (this.problemData.length > 0) {
      let theadKey = Object.keys(this.problemData[0]);
      list = theadKey.filter(
        (v, i) =>
          i > theadKey.indexOf("默认画质") && i < theadKey.indexOf("提单状态")
      );
    }
    return list;
  }
  public get stuck_baseline() {
    return {
      name: "主观卡顿",
      pass: ["流畅", "轻微卡顿", "中度卡顿"],
      no_pass: ["严重卡顿"],
    };
  }
  public get hot_baseline() {
    return {
      name: "主观发热",
      pass: ["温热", "轻微发热"],
      no_pass: ["严重发热"],
    };
  }
  public get crash_baseline() {
    return { name: "是否闪退", pass: ["否"], no_pass: ["闪退", "是"] };
  }
  public get fps_baseline() {
    return {
      Android: {
        "1档": { AvgFPS: 59, "MaxPSS(MB)": 2200, 最高温度: 0 },
        "2档": { AvgFPS: 59, "MaxPSS(MB)": 1900, 最高温度: 0 },
        "3档": { AvgFPS: 29, "MaxPSS(MB)": 1500, 最高温度: 0 },
        "4档": { AvgFPS: 29, "MaxPSS(MB)": 1500, 最高温度: 0 },
        "5档": { AvgFPS: 29, "MaxPSS(MB)": 1500, 最高温度: 0 },
      },
      iOS: {
        "1档": { AvgFPS: 29.5, "MaxPSS(MB)": 1450, 最高温度: 0 },
        "2档": { AvgFPS: 29.5, "MaxPSS(MB)": 1450, 最高温度: 0 },
        "3档": { AvgFPS: 29, "MaxPSS(MB)": 0, 最高温度: 0 },
        "4档": { AvgFPS: 29, "MaxPSS(MB)": 0, 最高温度: 0 },
        "5档": { AvgFPS: 29, "MaxPSS(MB)": 0, 最高温度: 0 },
      },
    };
  }
  public get pss_baseline() {
    return {
      Android: {
        精致: { "MaxPSS(MB)": 2200 },
        平衡: { "MaxPSS(MB)": 1900 },
        极速: { "MaxPSS(MB)": 1500 },
      },
      iOS: {
        精致: { "MaxPSS(MB)": 3000 },
        平衡: { "MaxPSS(MB)": 2000 },
        极速: { "MaxPSS(MB)": 1500 },
      },
    };
  }
  public get configurationList() {
    let list = [];
    list.push(this.stuck_baseline, this.hot_baseline, this.crash_baseline);
    return list;
  }
  public baseline_data = [];
  public height = "1000px";
  public get get_all_performance() {
    let res: any[] = readtopPerformance(store).results;
    for (let i = 0; i < res?.length; i++) {
      // res[i].model = this.getDeviceSpecs.filter(
      //   (item) => item.id === res[i].device_id
      // )[0]?.model.model;
      res[i].index = i + 1;
      res[i].timestamp = dateConversion(res[i].test_time);
      res[i].is_crash1 = res[i].is_crash == false ? "否" : "是";
      for (let x in res[i]) {
        if (res[i][x] == null) {
          res[i][x] = "-";
        }
      }
    }
    return res;
  }
  public get get_top_performance() {
    let res: any[] = readtopPerformanceList(store);

    return res;
  }
  public get get_top_performance_advance() {
    let res: any[] = readtopPerformanceListAdvance(store);

    return res;
  }
  //   public c=0
  //     async mounted(){
  //         console.log(this.ss())
  //           let n= await this.getData1()
  //         console.log(n)
  //        let c= await this.getData()
  //          console.log(this.ss())
  //          console.log(c)
  //     }
  //     public  target = 'Hello World'
  //     public ss(){
  //        return (this.target)
  //     }
  //    public getData(){
  //    return new Promise((resolve) =>{
  //      setTimeout(() => {
  //         resolve(this.target='2')
  //      }, 2000);
  //     })
  // }
  //    public getData1(){
  //    return new Promise((resolve) =>{
  //      setTimeout(() => {
  //         resolve(3123)
  //      }, 1000);
  //     })
  // }
}
